module.exports = __webpack_public_path__ + "static/media/printer-white.794c173a.svg";